<template>
    <div>
        <navbar navbar-menu-classes="navbar-left">
          <div>
            <router-link class="navbar-brand" to="/admin">
                <img :src="logo" alt="Kobotrack" style="display: inline"> Kobotrack</router-link>
          </div>
        </navbar>
        <navbar navbar-menu-classes="navbar-right">
            <template slot="navbar-menu">
                <router-link to="/login" class="nav-item" tag="li">
                    <a class="nav-link">
                    <i class="nc-icon"></i> Login
                    </a>
                </router-link>
            </template>
        </navbar>
    </div>
</template>

<script>
  import {Navbar} from 'src/components/UIComponents'
  export default {
    name: 'main-navbar',
    components: {
      Navbar
    },
    props: {
      logo: {
        type: String,
        default: 'static/img/kobotrack-logo.png'
      },
    }
  }
</script>

<style scoped>

</style>
